import api from "./api";
import { iniciarRequisicao, logout } from "../helpers";
import { STATUS_HTTP } from "./statusHTTP";

export const getDepartamentos = async (params) => {
  let url = '/relatorio-menu-dialog/departamentos';

  const {data, status} = await api.get(url, { headers: iniciarRequisicao(), params}).catch(logout);

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.departamentos;
  }

  logout();
};

export const getFornecedores = async (params) => {
  let url = '/relatorio-menu-dialog/fornecedores';

  const {data, status} = await api.get(url, { headers: iniciarRequisicao(), params}).catch(logout);

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.fornecedores;
  }

  logout();
};

export const getSecoes = async (params) => {
  let url = '/relatorio-menu-dialog/secoes';

  const {data, status} = await api.get(url, { headers: iniciarRequisicao(), params}).catch(logout);

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.secao;
  }

  logout();
};

export const getCategorias = async (params) => {
  let url = '/relatorio-menu-dialog/categorias';

  const {data, status} = await api.get(url, { headers: iniciarRequisicao(), params}).catch(logout);

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.categorias;
  }

  logout();
};

export const getDados = async (params) => {
  let url = '/relatorio_sazonalidade';

  const {data, status} = await api.get(url, { headers: iniciarRequisicao(), params}).catch(logout);

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.categorias;
  }

  logout();
};

class RelatorioAPI {

  async getProdutosTodal(headers, params) {
    const response = await api.get("/get_dialog_produtos_total", { headers, params });
    return response;
  }

  async getProdutosExcesso(headers, params) {
    const response = await api.get("/get_dialog_produtos_excesso", { headers, params });
    return response;
  }

  async getProdutosOk(headers, params) {
    const response = await api.get("/get_dialog_produtos_ok", { headers, params });
    return response;
  }

  async getProdutosAComprar(headers, params) {
    const response = await api.get("/get_dialog_produtos_a_comprar", { headers, params });
    return response;
  }

  async getProdutosEmTransito(headers, params) {
    const response = await api.get("/get_dialog_produtos_em_transito", { headers, params });
    return response;
  }

  async getProdutosPerdaVendaRuptura(headers, params) {
    const response = await api.get("/get_dialog_produtos_perda_venda_ruptura", { headers, params });
    return response;
  }

  async getCompradoresEmProdutosFilial(headers, params) {
    const response = await api.get("/get_compradores_produtos_filial", { headers, params });
    return response;
  }

  async getStatusProduto(headers, params) {
    const response = await api.get("/get_status_produto", { headers, params });
    return response;
  }

  async getProdutosStatusMensal(headers, params) {
    const response = await api.get("/get_produtos_status_mensal", { headers, params });
    return response;
  }

  async getProdutosNivelImportancia(headers, params) {
    const response = await api.get("/get_produtos_nivel_importancia", { headers, params });
    return response;
  }

  async getDetalhamentoRuptura(headers, params) {
    const response = await api.get("/get_detalhamento_ruptura", { headers, params });
    return response;
  }

  async getCompradoresEmPercepcaoCompras(headers, params) {
    const response = await api.get("/get_compradores_percepcao_compras", { headers, params });
    return response;
  }

  async getSegmentos(headers, params) {
    const response = await api.get("/get_segmentos", { headers, params });
    return response;
  }

  async getMarcas(headers, params) {
    const response = await api.get("/get_marcas", { headers, params });
    return response;
  }

  async getFornecedorPorSegmentos(headers, params) {
    const response = await api.get("/get_fornecedor_por_segmentos", { headers, params });
    return response;
  }

  async getProdutoPorFilial(headers, params) {
    const response = await api.get("/get_produto_por_filial", { headers, params });
    return response;
  }

  async getProdutosPercepcaoCompra(headers, params) {
    const response = await api.get("/get_produtos_percepcao_compra", { headers, params });
    return response;
  }

  async getNivelEstoque(headers, params) {
    const response = await api.get("/get_niveis_estoque", { headers, params});
    return response;
  }

  async exportarCoberturaEstoqueExcell(headers) {
    const response = await api.get("/relatorio_cobertura_estoque_fornecedor", { headers });
    return response;
  }

}

export default new RelatorioAPI();
